import { Inject, Injectable, Injector, PLATFORM_ID } from "@angular/core";
import { HttpInterceptor } from "@angular/common/http";
import { UserService } from "./app/shared/services/user.service";
import { MasterApiService } from "./app/shared/services/master-api.service";
import { SsrCookieService } from "ngx-cookie-service-ssr";
import { isPlatformServer } from "@angular/common";
// import * as bcrypt from "bcryptjs";
// import * as CryptoJS from 'crypto-js';
// import cryptoRandomString from 'crypto-random-string';
// import { createHmac, randomBytes } from 'crypto'; // Node.js built-in
import * as CryptoJS from 'crypto-js';
//import { randomBytes } from 'crypto';


@Injectable()
export class TokenInterceptorService implements HttpInterceptor {

  constructor(
    private injector: Injector,
    public masterApiService: MasterApiService,
    private cookies: SsrCookieService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
  }
  

    generateNonce(length: number): string {
      const charset = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      const charsetLength = charset.length;
      let result = '';

      if (typeof window !== 'undefined' && window.crypto && window.crypto.getRandomValues) {
        // Browser environment
        const values = new Uint8Array(length);
        window.crypto.getRandomValues(values);
        for (let i = 0; i < length; i++) {
          result += charset[values[i] % charsetLength];
        }
      } else {
        // Server environment
        const crypto = require('crypto');
        const values = crypto.randomBytes(length);
        for (let i = 0; i < length; i++) {
          result += charset[values[i] % charsetLength];
        }
      }

      return result;
    }



  intercept(req: any, next: any) {
    var authService = this.injector.get(UserService);
    let lang = "";
    if (isPlatformServer(this.platformId)) {
      lang = this.cookies.get("front-lang")
        ? this.cookies.get("front-lang")
        : "ar";
    } else {
      lang = this.cookies.get("front-lang")
        ? this.cookies.get("front-lang")
        : "ar";
    }
    // const secretKey = 'it-Plus-Secrit-Key-API-matjer';
    // const passwordHashed = bcrypt.hashSync(secretKey);

    const secretKey = 'it-Plus-Secrit-Key-API';
    const timestamp = new Date().toISOString();
    const nonce = this.generateNonce(32); 
    const data = `${timestamp}:${nonce}`;
    const signature = CryptoJS.HmacSHA256(data,secretKey).toString();
;

    if (authService.getUserToken()) {
      var tokenizedReq = req.clone({
        setHeaders: {
          "front-lang": lang,
          "user-token": authService.getUserToken(),
          "affiliator-token": this.masterApiService.masterData.shop_token,
          "dealer-token":
            this.masterApiService.masterData.dealer_token + "-" + Date.now(),
          // "Device-Id": authService.getDeviceId()
          "Device-Id": localStorage.getItem("Device-Id")
            ? localStorage.getItem("Device-Id")
            : "",
          "App-Version": this.masterApiService.AppVersion,
          "Date-Offset": Intl.DateTimeFormat().resolvedOptions().timeZone, // Add timezone offset

          'X-Timestamp': timestamp,
          'X-Nonce': nonce,
          'X-Signature': signature
        },
      });
    } else {
      var tokenizedReq = req.clone({
        setHeaders: {
          "front-lang": lang,
          // "affiliator-token": environment.affiliator_token,
          "dealer-token":
            this.masterApiService.masterData.dealer_token + "-" + Date.now(),
          "affiliator-token": this.masterApiService.masterData.shop_token,
          // "Device-Id": authService.getDeviceId()
          "Device-Id": localStorage.getItem("Device-Id")
            ? localStorage.getItem("Device-Id")
            : "",
          "App-Version": this.masterApiService.AppVersion,
          'X-Timestamp': timestamp,
          'X-Nonce': nonce,
          'X-Signature': signature,
          "Date-Offset": Intl.DateTimeFormat().resolvedOptions().timeZone
        },
      });
    }

    return next.handle(tokenizedReq);
  }
}


/** 
  {
    "dealer_id": "1",
    "affiliator_id": "121",
    "domain": "zahraegypt.com",
    "user_name": "GOGET",
    "package_name_android": "app.zahra.egypt",
    "package_name_ios": "app.zahra.egypt",
    "app_store_id": "6448218709",
    "dynamic_link": "https://zahraegypt.page.link",
    "site_url": "https://api-develop.malyaan.net",
    "img_url": "https://api-develop.malyaan.net/uploads/malyaan",
    "shop_token": "$2y$10$oWVX50EVQ6JcD3wYmT2VrOaJU4vyB7TkO55.nNzfDTW7jh30L3RgO",
    "dealer_token": "$2y$10$SgY2cwe70xDA1w8Vn.yCYOZHKV8lpTEl.ZJZnw6FfpDiZX/.cx6ma-GOGET",
    "success": true
  }
*/